export default __webpack_public_path__ + "static/media/user-20-rule.6f4e1395.svg";